const audioLib = require('@/services/audio-lib').default;

function getBallLetter(ballId) {
  var idLetter = '';
  if (ballId >= 1 && ballId <= 15) idLetter = 'B';
  if (ballId >= 16 && ballId <= 30) idLetter = 'I';
  if (ballId >= 31 && ballId <= 45) idLetter = 'N';
  if (ballId >= 46 && ballId <= 60) idLetter = 'G';
  if (ballId >= 61) idLetter = 'O';

  return idLetter;
}

const getLastBallId = (ballidsString) => {
  const ballids = ballidsString.split(',');
  return ballids[ballids.length - 1];
};

export { getBallLetter, getLastBallId };

